module.exports = __webpack_public_path__ + "static/media/sc1.1e3d61ad.png";